module.exports = __webpack_public_path__ + "img/unicore.032c3a3d.png";